function buildEpiItensPayload(itens, rootDataEntrega, parseNullableDate) {
  return (itens || []).map((item) => {
    const hasInsumo = !!item?.insumo?.id;
    const itemPayload = {
      gloAtividadeId: item?.atividade?.id || item?.gloAtividadeId || null,
      quantidade: Number(item?.quantidade || 0),
      dataEntrega:
        parseNullableDate(item?.dataEntrega) || rootDataEntrega || null,
      certificadoAprovacao: item?.certificadoAprovacao || null,
      dataValidadeEpi: parseNullableDate(item?.dataValidadeEpi),
      dataDevolucao: parseNullableDate(item?.dataDevolucao),
    };

    if (hasInsumo) {
      return {
        ...itemPayload,
        gloInsumoId: item?.insumo?.id,
      };
    }

    return {
      ...itemPayload,
      itemDescricao: item?.itemEscrito || null,
    };
  });
}

export { buildEpiItensPayload };

